import { Component } from '@angular/core';
import { ListComponent } from 'src/app/common/component/list.component';

@Component({
	selector: 'app-optional-trip-list',
	templateUrl: './optional-trip-list.component.html',
	styleUrls: ['./optional-trip-list.component.css'],
})
export class OptionalTripListComponent extends ListComponent {
	protected apiUrl = 'optional_trip';
	protected apiType = 'bag';
	tableRows = [
		{ id: 'name', name: 'Nazwa' },
		{ id: 'isActive', name: 'Aktywna' },
		{ id: 'description', name: 'Opis' },
		{ id: 'optionalTripLocationsName', name: 'Lokalizacje' },
	];

	filters = {
		limit: '9999',
	};

	protected convertData(data: any) {
		return data.results.map((obj) => {
			const OptionalTripLocation = [];
			obj.optionalTripLocations.filter((item) => {
				OptionalTripLocation.push(item.location.name);
			});
			obj.optionalTripLocationsName = OptionalTripLocation;
			obj.isActive = obj.isActive ? 'Tak' : 'Nie';
			obj.description = obj.description.slice(0, 45) + '...';
			return obj;
		});
	}
}
